import React, { useEffect, useState } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import AdminLayout from '../../components/Admin/AdminLayout'
import { AdminKpiCard, trendDirFromPct } from './adminUi'

export default function AdminUsersStats() {
  const [data, setData] = useState(null)

  useEffect(() => {
    axios.get('/api/admin/users-stats')
      .then((r) => setData(r.data))
      .catch(() => toast.error('Failed to load usage stats'))
  }, [])

  const stats = data?.stats || {}

  return (
    <AdminLayout>
      <div className="admin-period-bar">
        <span className="admin-period-meta" style={{ fontSize: 13, color: '#909399' }}>
          DAU = chat senders today · WAU = active users (7d) · MAU = active users (30d)
        </span>
      </div>

      <div className="admin-kpi-row cols-5">
        <AdminKpiCard icon="users" color="blue" label="DAU" value={stats.dau ?? '—'} trend={stats.dauTrend} trendDir={trendDirFromPct(stats.dauTrend)} />
        <AdminKpiCard icon="calendar" color="green" label="WAU" value={stats.wau ?? '—'} trend={stats.wauTrend} trendDir={trendDirFromPct(stats.wauTrend)} />
        <AdminKpiCard icon="chart" color="purple" label="MAU (30d)" value={stats.mau ?? '—'} trend={stats.mauTrend} trendDir={trendDirFromPct(stats.mauTrend)} />
        <AdminKpiCard icon="timer" color="orange" label="Avg Session" value={stats.avgSession ?? 'N/A'} />
        <AdminKpiCard icon="chat" color="blue" label="Messages (30d)" value={stats.messages30d ?? '—'} trend={stats.messages30dTrend} trendDir={trendDirFromPct(stats.messages30dTrend)} />
      </div>

      <div className="admin-content-grid">
        <div className="admin-card">
          <div className="admin-card-header">
            <span className="admin-card-title">Daily Chat Senders (Last 7 Days)</span>
          </div>
          <div className="admin-chart-bars sm">
            {(data?.weeklyActive || []).map((d) => (
              <div key={d.label} className="admin-bar-col">
                <div className="admin-bar single" style={{ height: `${Math.max(d.heightPct || 0, 4)}%`, background: '#0f3d8a' }} />
                <span className="admin-bar-label">{d.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="admin-card">
          <div className="admin-card-header">
            <span className="admin-card-title">Top Features</span>
          </div>
          <div className="admin-feature-list">
            {(data?.topFeatures || []).map((f) => (
              <div key={f.name} className="admin-feature-row">
                <span>{f.icon}</span>
                <span className="admin-feature-name">{f.name}</span>
                <div className="admin-feature-bar-wrap">
                  <div className="admin-feature-bar" style={{ width: `${f.pct}%` }} />
                </div>
                <span className="admin-feature-pct">{f.pct}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <span className="admin-card-title">Active Users by Role</span>
        </div>
        <div className="admin-breakdown-list compact">
          {(data?.roleUsage || []).map((r) => (
            <div key={r.role} className="admin-breakdown-item">
              <div className="admin-breakdown-info">
                <div className="admin-breakdown-name">{r.role}</div>
              </div>
              <div className="admin-breakdown-right">
                <div className="admin-breakdown-amount">{r.activeUsers ?? r.sessions ?? 0}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  )
}
